import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ThinArrowUpIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 14.5L12 9L17.5 14.5" stroke="currentColor"/>
    </svg>
)
const ThinArrowUpIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ThinArrowUpIconSvg}
    </SvgIcon>
);
export default ThinArrowUpIcon